exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blur[data-v-211f36d4]{text-transform:uppercase;background-color:rgba(51,51,51,.8);padding:10px;margin-bottom:15px}.blur-p[data-v-211f36d4]{background-color:rgba(51,51,51,.8);padding:10px;display:inline!important;border-radius:50px}.carousel-inner[data-v-211f36d4]{border-radius:10px;-webkit-box-shadow:0 2px 30px 10px rgba(0,0,0,.4);-moz-box-shadow:0 2px 30px 10px rgba(0,0,0,.4);box-shadow:0 2px 30px 10px rgba(0,0,0,.4)}.carousel-caption[data-v-211f36d4]{width:100%!important;left:0!important}.img-fluid[data-v-211f36d4]{max-height:600px!important;object-fit:cover!important}.before-enter[data-v-211f36d4]{opacity:0;transform:scale(.5);transition:all 1s cubic-bezier(.42,.01,.51,1.49)}.enter[data-v-211f36d4]{opacity:1;transform:scaleY(1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-211f36d4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Slider.vue
// module id = 159
// module chunks = 0